module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [(_vm.$route.params.systemId) ? _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticClass: "padding-top-10px",
    attrs: {
      "src": require("./logo.png"),
      "alt": "SGS DO BRASIL"
    },
    on: {
      "click": function($event) {
        return _vm.goToBusinessArea()
      }
    }
  })]) : _c('img', {
    staticClass: "padding-top-10px",
    attrs: {
      "src": require("./logo.png"),
      "alt": "SGS DO BRASIL"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-155b3c25!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/header/brand.vue
// module id = 888
// module chunks = 2